import { withStyles } from '@material-ui/core';

import ButtonsField from './component';
import styles from './styles';

export default withStyles(styles)(ButtonsField);
